import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import { BrowserRouter, createBrowserRouter } from "react-router-dom"
import "./i18n"
import { Provider } from "react-redux"

import store from "./store"
import Root from "Root"
import { userDetails } from "store/actions/authAction"
import { changeLayout } from "store/actions"
import TenantProvider from "context/TenantContext"
import { getAuthToken, isTokenExpired } from "utils/tokenManager"
import { endSession } from "utils/endSession"
import logger from "utils/logger"
import { completeTenantLoginRedirect } from "utils/apiForbiddenRedirect"

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      {
        path: "/dashboard",
        // element: <Home />,
        loader: "homeLoader",
      },
    ],
  },
])

const { Login: { isLoggedIn } = {} } = store.getState() || {}

const initialLayoutType = store.getState()?.Layout?.layoutType
if (initialLayoutType) {
  store.dispatch(changeLayout(initialLayoutType))
}

// Only dispatch userDetails when a non-expired token is present
completeTenantLoginRedirect()

const storedToken = getAuthToken()
if (isLoggedIn && storedToken && !isTokenExpired(storedToken)) {
  store.dispatch(userDetails())
} else if (isLoggedIn && (!storedToken || isTokenExpired(storedToken))) {
  endSession()
}

// Global error handlers for unhandled exceptions and promise rejections
window.onerror = (message, source, lineno, colno, error) => {
  logger.error("[Global] Uncaught error", { message, source, lineno, colno, error })
}

window.onunhandledrejection = event => {
  logger.error("[Global] Unhandled promise rejection", event.reason)
}

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <Provider store={store}>
    <TenantProvider>
      <React.Fragment>
        <BrowserRouter>
          <App router={router} />
        </BrowserRouter>
      </React.Fragment>
    </TenantProvider>
  </Provider>
)

